module.exports = __webpack_public_path__ + "img/LATIN10_16.400447dc.jpg";